import { render } from "./DefinirRegrasPessoas.vue?vue&type=template&id=37af74e1&scoped=true"
import script from "./DefinirRegrasPessoas.vue?vue&type=script&lang=js"
export * from "./DefinirRegrasPessoas.vue?vue&type=script&lang=js"

import "./DefinirRegrasPessoas.vue?vue&type=style&index=0&id=37af74e1&lang=sass"
import "./DefinirRegrasPessoas.vue?vue&type=style&index=1&id=37af74e1&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37af74e1"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QTable,QInput,QCard,QCardSection,QCheckbox,QSeparator,QTd,QBtn,QPagination,QSelect});
